import { Tag } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  style?: React.CSSProperties;
}

export const AgentTipperTag = ({ style }: Props) => {
  const { t } = useTranslation();

  return (
    <Tag color="geekblue" style={style}>
      {t("agent.helpers.tipper")}
    </Tag>
  );
};
